"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Small = _interopRequireDefault(require("../elements/Small"));

var _H = _interopRequireDefault(require("../elements/headings/H5"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UISliderTickMark = _interopRequireDefault(require("./internal/UISliderTickMark"));

var _UISliderTrack = require("./internal/UISliderTrack");

var _UIAbstractSlider = _interopRequireDefault(require("./abstract/UIAbstractSlider"));

var _TabIndex = require("../utils/TabIndex");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var getFirstDefinedValue = function getFirstDefinedValue() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (val) {
    return val != null;
  });
};

var getAdjustedValue = function getAdjustedValue(min, max, step, rawValue) {
  if (rawValue < min) return min;
  if (rawValue > max) return max;

  if (Math.abs(rawValue % step) !== 0) {
    return Math.round(rawValue / step) * step;
  }

  return rawValue;
};

var getControlPositionFromValue = function getControlPositionFromValue(min, max, adjustedValue) {
  if (max - min === 0) {
    return 0;
  }

  return (adjustedValue - min) / (max - min) * 100;
};

var SLIDER_LABELS = {
  max: 'private-slider__label--max',
  min: 'private-slider__label--min'
};

var UISlider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UISlider, _Component);

  function UISlider() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UISlider);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UISlider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isDragging: false
    };

    _this.handleChange = function (rawValue) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          max = _this$props.max,
          min = _this$props.min,
          onChange = _this$props.onChange,
          onRawValueChange = _this$props.onRawValueChange,
          readOnly = _this$props.readOnly,
          step = _this$props.step,
          value = _this$props.value,
          trackStart = _this$props.trackStart,
          trackEnd = _this$props.trackEnd;

      if (disabled || readOnly) {
        return;
      }

      var adjustedRawValue = getAdjustedValue(trackStart, trackEnd, step, rawValue);
      (0, _Functions.callIfPossible)(onRawValueChange, (0, _SyntheticEvent.default)(adjustedRawValue));
      var newValue = getAdjustedValue(min, max, step, rawValue);

      if (value !== newValue) {
        onChange((0, _SyntheticEvent.default)(newValue));
      }
    };

    _this.handleKeyDown = function (evt) {
      var _this$props2 = _this.props,
          step = _this$props2.step,
          value = _this$props2.value;
      var nextValue = value || 0;

      if (evt.key === 'ArrowLeft' || evt.key === 'ArrowDown') {
        evt.preventDefault();
        nextValue = value - step;
      } else if (evt.key === 'ArrowRight' || evt.key === 'ArrowUp') {
        evt.preventDefault();
        nextValue = value + step;
      }

      _this.handleChange(nextValue);

      (0, _Functions.callIfPossible)(_this.props.onKeyDown, evt);
    };

    _this.handleDrag = function (evt) {
      var percentX = evt.target.value.percentX;

      _this.handleChange(_this.getControlValueFromPercentX(percentX));
    };

    _this.handleDragStart = function () {
      _this.setState({
        isDragging: true
      });
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isDragging: false
      });
    };

    _this.handleMinLabelClick = function () {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          min = _this$props3.min,
          readOnly = _this$props3.readOnly;
      if (!disabled && !readOnly) _this.handleChange(min);
    };

    _this.handleMaxLabelClick = function () {
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          max = _this$props4.max,
          readOnly = _this$props4.readOnly;
      if (!disabled && !readOnly) _this.handleChange(max);
    };

    return _this;
  }

  (0, _createClass2.default)(UISlider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.isDragging && this.state.isDragging) {
        this.addBodyDragCursorClass();
      } else if (prevState.isDragging && !this.state.isDragging) {
        this.removeBodyDragCursorClass();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeBodyDragCursorClass();
    }
  }, {
    key: "addBodyDragCursorClass",
    value: function addBodyDragCursorClass() {
      document.body.classList.add('hubspot-drag-cursor');
    }
  }, {
    key: "removeBodyDragCursorClass",
    value: function removeBodyDragCursorClass() {
      document.body.classList.remove('hubspot-drag-cursor');
    }
  }, {
    key: "getControlValueFromPercentX",
    value: function getControlValueFromPercentX(percentX) {
      var min = getFirstDefinedValue(this.props.trackStart, this.props.min, 0);
      var max = getFirstDefinedValue(this.props.trackEnd, this.props.max, 0);
      return percentX * (max - min) + min;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(shorthandSize, value, label, name) {
      var use = shorthandSize === 'lg' ? null : 'help';
      var calculatedClassName = (0, _classnames.default)('private-slider__label', SLIDER_LABELS[name]);
      var Label = shorthandSize === 'lg' ? _H.default : _Small.default;
      return _react.default.createElement(Label, {
        className: calculatedClassName,
        onClick: name === 'min' ? this.handleMinLabelClick : this.handleMaxLabelClick,
        use: use
      }, label || value);
    }
  }, {
    key: "renderTrackSegment",
    value: function renderTrackSegment(disabled, readOnly, restrictedAreaTooltip, shorthandSize, _ref) {
      var value = _ref.value,
          restricted = _ref.restricted,
          width = _ref.width,
          left = _ref.left,
          trackSegmentProps = (0, _objectWithoutProperties2.default)(_ref, ["value", "restricted", "width", "left"]);

      if (width <= 0) {
        return null;
      }

      var track = _react.default.createElement(_UISliderTrack.UISliderTrackSegment, Object.assign({}, trackSegmentProps, {
        left: left,
        width: width,
        size: shorthandSize === 'lg' ? shorthandSize : 'md',
        restricted: restricted,
        disabled: disabled,
        readOnly: readOnly,
        value: value
      }));

      if (restrictedAreaTooltip) {
        var tooltipTitle = typeof restrictedAreaTooltip === 'function' ? restrictedAreaTooltip(value > 0 ? 'upper' : 'lower') : restrictedAreaTooltip;
        return _react.default.createElement(_UITooltip.default, {
          title: tooltipTitle,
          placement: "bottom"
        }, track);
      }

      return track;
    }
  }, {
    key: "renderTickMarks",
    value: function renderTickMarks(min, value, step, renderedMax, renderedMin) {
      var numberOfTickMarks = (renderedMax - renderedMin) / step;
      var tickMarks = [];

      for (var i = 0; i <= numberOfTickMarks; i++) {
        tickMarks.push(_react.default.createElement(_UISliderTickMark.default, {
          currentSliderValue: value,
          key: i,
          value: i * step + renderedMin,
          min: min
        }));
      }

      return tickMarks;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          className = _this$props5.className,
          disabled = _this$props5.disabled,
          min = _this$props5.min,
          minLabel = _this$props5.minLabel,
          max = _this$props5.max,
          maxLabel = _this$props5.maxLabel,
          trackStart = _this$props5.trackStart,
          trackEnd = _this$props5.trackEnd,
          __onChange = _this$props5.onChange,
          __onRawValueChange = _this$props5.onRawValueChange,
          readOnly = _this$props5.readOnly,
          size = _this$props5.size,
          showLabels = _this$props5.showLabels,
          showTickMarks = _this$props5.showTickMarks,
          step = _this$props5.step,
          tabIndex = _this$props5.tabIndex,
          value = _this$props5.value,
          restrictedAreaTooltip = _this$props5.restrictedAreaTooltip,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["className", "disabled", "min", "minLabel", "max", "maxLabel", "trackStart", "trackEnd", "onChange", "onRawValueChange", "readOnly", "size", "showLabels", "showTickMarks", "step", "tabIndex", "value", "restrictedAreaTooltip"]);

      if (process.env.NODE_ENV !== 'production') {
        if (Math.abs(min % step) !== 0 || Math.abs(max % step) !== 0) {
          _devLogger.default.warn({
            message: 'UISlider: Min and max value should be a multiple of the step',
            key: 'UISlider: Min or max not a multiple of the step'
          });
        }

        if (trackStart != null && trackStart > min) {
          _devLogger.default.warn({
            message: 'UISlider: trackStart value should be less than the min',
            key: 'UISlider: trackStart greater than min'
          });
        }

        if (trackEnd != null && trackEnd < max) {
          _devLogger.default.warn({
            message: 'UISlider: trackEnd value should be greater than the max',
            key: 'UISlider: trackEnd less than max'
          });
        }
      }

      var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
      var computedClassName = (0, _classnames.default)(className, 'private-slider', {
        'private-slider--disabled': disabled,
        'private-slider--readonly': readOnly,
        'private-slider--dragging': this.state.isDragging,
        'private-slider--large': shorthandSize === 'lg'
      });
      var adjustedValue = getAdjustedValue(min, max, step, value);
      var renderedMin = getFirstDefinedValue(trackStart, min, 0);
      var renderedMax = getFirstDefinedValue(trackEnd, max, 0);
      var trackLength = renderedMax - renderedMin;
      var controlPosition = getControlPositionFromValue(renderedMin, renderedMax, adjustedValue);
      var percentRestrictedLower = 0;
      var percentRestrictedUpper = 0;
      var percentFilled = 0;
      var percentAvailable = 0;

      if (trackLength > 0) {
        percentRestrictedLower = (min - renderedMin) / trackLength * 100;
        percentRestrictedUpper = (renderedMax - max) / trackLength * 100;
        percentFilled = controlPosition - percentRestrictedLower;
        percentAvailable = 100 - percentRestrictedUpper - controlPosition;
      }

      return _react.default.createElement("div", Object.assign({}, rest, {
        "aria-disabled": disabled,
        "aria-readonly": readOnly,
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": value || 0,
        "aria-valuetext": "" + (value || 0),
        className: computedClassName,
        onKeyDown: this.handleKeyDown,
        role: "slider",
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex)
      }), showLabels && this.renderLabel(shorthandSize, renderedMin, minLabel, 'min'), _react.default.createElement(_UIAbstractSlider.default, {
        className: "private-slider__slider",
        onDrag: this.handleDrag,
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd
      }, _react.default.createElement("div", {
        className: "private-slider__slider-track"
      }, _react.default.createElement("div", {
        className: "private-slider__tickmarks"
      }, showTickMarks && this.renderTickMarks(min, value, step, renderedMax, renderedMin)), this.renderTrackSegment(disabled, readOnly, restrictedAreaTooltip, shorthandSize, {
        width: percentRestrictedLower,
        restricted: true,
        value: -1
      }), this.renderTrackSegment(disabled, readOnly, null, shorthandSize, {
        left: percentRestrictedLower,
        width: percentFilled,
        value: 0
      }), this.renderTrackSegment(disabled, readOnly, null, shorthandSize, {
        left: controlPosition,
        width: percentAvailable,
        value: 1
      }), this.renderTrackSegment(disabled, readOnly, restrictedAreaTooltip, shorthandSize, {
        left: controlPosition + percentAvailable,
        width: percentRestrictedUpper,
        restricted: true,
        value: 1
      }), _react.default.createElement("div", {
        className: "private-slider__control",
        style: {
          left: controlPosition + "%"
        }
      }))), showLabels && this.renderLabel(shorthandSize, renderedMax, maxLabel, 'max'));
    }
  }]);
  return UISlider;
}(_react.Component);

UISlider.propTypes = {
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onRawValueChange: _propTypes.default.func,
  min: _propTypes.default.number,
  minLabel: _propTypes.default.node,
  max: _propTypes.default.number.isRequired,
  maxLabel: _propTypes.default.node,
  trackStart: _propTypes.default.number,
  trackEnd: _propTypes.default.number,
  onKeyDown: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onMouseMove: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  showLabels: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['lg']), _propTypes.default.oneOf(['default'])]),
  step: _propTypes.default.number.isRequired,
  showTickMarks: _propTypes.default.bool,
  value: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  restrictedAreaTooltip: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
};
UISlider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: null
};
UISlider.displayName = 'UISlider';

var _default = (0, _Controllable.default)(UISlider);

exports.default = _default;
module.exports = exports.default;